'use client'

export const deleteItemClient = async (id: string) => {
    const { actionDeleteItem } = await import('./cartActions')
    return actionDeleteItem(id)
}

export const changeQtyClient = async (id: string, qty: number) => {
    const { actionChangeQty } = await import('./cartActions')
    return actionChangeQty(id, qty)
}

export const clearCartClient = async () => {
    const { actionClearCart } = await import('./cartActions')
    return actionClearCart()
}

export const addCartClient = async (id: string, qty: number) => {
    
    const { actionAddCartItem } = await import('./cartActions')
    console.log('ПРОЕРКА КЛИЕНТСКАЯ ДОАБВКА В КОРЗУ', id, qty)
    return actionAddCartItem(id, qty)
}

// order

export const orderPostClient = async (
    phone: string,
    email: string,
    delivery_address: string,
    comment: string,
) => {
    const { actionCreateOrder } = await import('./orderActions')
    return actionCreateOrder(phone, email, delivery_address, comment)
}
